import React from "react"
import Modal from "aldoo-ra/Modal"
import { providerOf, officeAddress } from "./providers"
import BackOrCloseIcon from "../../ui/BackOrCloseIcon"

/**
 * Where an office or a locker is, on a map, in the site's own dialog (full
 * screen with its header on a phone; the admin screens pass their variant):
 * the provider's own map opened at the office when it has one (providers.js),
 * a map of its address otherwise.
 */
export default function OfficeMapDialog({ isOpen, onClose, providerId, office, language, variant = "sf_dialog" }) {
  if (!office) return null
  const map = providerOf(providerId).map
  const src = map
    ? map.url({ officeType: office.type, language, officeId: office.id, city: office.city })
    : `https://maps.google.com/maps?q=${encodeURIComponent(Number.isFinite(Number(office.lat)) && office.lat !== null ? `${office.lat},${office.lng}` : [office.address, office.city].filter(Boolean).join(", ") || office.name)}&output=embed`
  // the storefront's full-screen dialog (the map takes every pixel under the
  // header on a phone); the admin passes its own
  const full = variant === "sf_dialog"
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant={full ? "sf_dialog_back" : variant}
      closeIcon={full ? BackOrCloseIcon : undefined}
      title={office.name}
      closeOnEscape
      className={full ? "" : "md:w-[92vw] md:max-w-[1100px] md:h-[85vh] md:max-h-[85vh]"}
    >
      <div className={full ? "flex-1 min-h-0 flex flex-col gap-2 -mx-5 -mb-5 md:mx-0 md:mb-0" : "flex flex-col gap-2"} data-testid="office-map-dialog">
        {office.address && <p className="m-0 px-5 md:px-0 text-center text-[14px] text-text_secondary">{officeAddress(office)}</p>}
        <iframe
          title={office.name}
          src={src}
          className={full ? "flex-1 min-h-0 w-full border-0 md:border md:border-bordered md:rounded-lg" : "w-full h-[calc(85vh-150px)] rounded-lg border border-bordered"}
          allow="geolocation"
          loading="lazy"
        />
      </div>
    </Modal>
  )
}
